<template>
  <div class="cross-chain-record-manage">
    <action-bar>
      <btn-style :btn-list="btnList"></btn-style>
    </action-bar>
    <common-bg-plate>
      <normal-table
        ref="commonTable"
        :table-col="tableCol"
        :table-data="list"
        :operator="operator"
        :operate-col="operateCol"
        :show-edit="true"
        :paging="paging"
        @pagination="handleSizeOrPageChange"
      >
        <template slot="status" slot-scope="{ param }">
          <span class="record-status" :class="param.row.status | transStatusClass">{{
            param.row.status | transStatus($constants.EMPTY)
          }}</span>
        </template>
      </normal-table>
    </common-bg-plate>
    <create-node ref="createNode" @update:list="getList()"></create-node>
    <detailsResult ref="detailsResult"></detailsResult>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import createNode from './createCrossRecordNode'
import detailsResult from './detailsResult'

export default {
  name: 'CrossChainRecord',
  components: {
    createNode,
    detailsResult
  },
  filters: {
    transStatus: function(value, defaultVal) {
      if (value == -1) {
        return '处理中'
      } else if (value == 0) {
        return '成功'
      } else if (value == 3) {
        return '请稍后再查询'
      } else {
        return '失败'
      }
    },
    transStatusClass: function(value) {
      if (value == -1) {
        return 'is-running '
      } else if (value == 0) {
        return 'is-success'
      } else if (value == 3) {
        return 'is-waiting'
      } else {
        return 'is-failed'
      }
    }
  },
  data() {
    return {
      inputContent: '',
      fullscreenLoading: false, //下载loading
      crosschainId: '',
      btnList: [
        {
          btnContent: '发起跨链交易',
          click: () => {
            return this.createExpansionNode()
          },
          icon: 'icon-add',
          isDisable: () => JSON.parse(this.$route.query.detail).status != 1
        },
        {
          btnContent: '刷新',
          click: () => {
            return this.handleRefresh()
          },
          icon: 'icon-refresh',
          isDisable: () => JSON.parse(this.$route.query.detail).status != 1
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'id',
          label: 'ID',
          minWidth: 100
        },
        {
          prop: 'crossId',
          label: '跨链ID',
          minWidth: 300
        },
        {
          prop: 'status',
          label: '状态',
          slotName: 'status',
          minWidth: 150
        },
        {
          prop: 'msg',
          label: '原因',
          minWidth: 300
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 179
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '调用参数',
          click: (row, col, cellValue) => {
            return this.handleDetails(row)
          },
          icon: 'icon-check',
          showText: true
        },
        {
          text: '详细结果',
          click: (row, col, cellValue) => {
            return this.showDetailResult(row)
          },
          formatter: row => {
            return row.status == 0
          },
          icon: 'icon-check',
          showText: true
        }
      ],
      operateCol: {
        minWidth: 170
      }
    }
  },
  computed: {
    ...mapState({
      list: state => state.crossChainRecord.crosschainrecord_list,
      paging: state => state.crossChainRecord.crosschainrecord_paging
    })
  },

  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getRecordtLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        crossChainId: JSON.parse(this.$route.query.detail).id
      }
      this.getRecordtLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    createExpansionNode(row) {
      this.$refs.createNode.handleOpen()
    },
    handleRefresh() {
      this.getList()
    },
    handleDetails(row) {
      this.$refs.createNode.handleOpen(row)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    showDetailResult(row) {
      this.$refs.detailsResult.handleOpen(row)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
@include theme(
  'cross-chain-record-manage',
  (
    --cross-chain-manage-list-operate-color: #45c2ff,
    --cross-chain-manage-list-status-subscribe-color: #55da62,
    --cross-chain-manage-list-status-unsubscribe-color: #e95757,
    --cross-chain-manage-list-status-unsubscribe-background-color: rgba(233, 87, 87, 0.34),
    --cross-chain-manage-list-record-status-wating: #45c2ff,
    --cross-chain-manage-list-record-status-running: #fac20a,
    --cross-chain-manage-list-record-status-success: #55da62,
    --cross-chain-manage-list-record-status-failed: #e95757
  ),
  (
    --cross-chain-manage-list-operate-color: #45c2ff,
    --cross-chain-manage-list-status-subscribe-color: #55da62,
    --cross-chain-manage-list-status-unsubscribe-color: #e95757,
    --cross-chain-manage-list-status-unsubscribe-background-color: rgba(233, 87, 87, 0.34),
    --cross-chain-manage-list-record-status-wating: #45c2ff,
    --cross-chain-manage-list-record-status-running: #fac20a,
    --cross-chain-manage-list-record-status-success: #55da62,
    --cross-chain-manage-list-record-status-failed: #e95757
  )
);
.cross-chain-record-manage {
  --cross-chain-manage-list-min-height: var(
    --base-main-router-body-avaliable-height-with-action-bar
  );
  .normal-table-wrap {
    height: 100%;
    min-height: var(--cross-chain-manage-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--cross-chain-manage-list-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--cross-chain-manage-list-min-height);

        .record-status {
          &.is-waiting {
            color: var(--cross-chain-manage-list-record-status-waiting);
          }

          &.is-success {
            color: var(--cross-chain-manage-list-record-status-success);
          }

          &.is-failed {
            color: var(--cross-chain-manage-list-record-status-failed);
          }

          &.is-running {
            color: var(--cross-chain-manage-list-record-status-running);
          }
        }

        .operate-item {
          color: var(--cross-chain-manage-list-operate-color);
        }
      }
    }
  }
}
</style>
